import axios from 'axios';


async function axiosRequest<T>(axiosPromise: Promise<T>): Promise<T> {
  try {
    return await axiosPromise;
  } catch (error: any) {
    if (axios.isAxiosError(error)) {
      // Do NOT redirect on 401 here. PermissionsContext + RequireAuth handle
      // unauthenticated state globally without causing a full page reload loop.
      throw error;
    }
    throw error;
  }
}

export async function getDashboard(): Promise<any> {
  try {
    const response = await axiosRequest(axios.get("/api/data/validation_reports", {
      withCredentials: true,
    }));
    return response.data;
  } catch (error: any) {
    // checkStatus(error.response.status);
    if (axios.isAxiosError(error)) {
      throw error;
    }
    throw error;
  }
}


export async function getRulebookData(): Promise<any> {
  try {
    const response = await axiosRequest(axios.get('/api/rules/view_rulebook', {
      withCredentials: true,
    }));
    return response.data;
  } catch (error) {
    // Axios errors can be typed more specifically if desired
    if (axios.isAxiosError(error)) {
      throw error;
    }
    throw error;
  }
}

export async function download_Rulebook(version: any) {
  try {
    const email = localStorage.getItem("useremail");
    const response = await axiosRequest(axios.get(`/api/rules/download_rulebook?email=${email}&version=${version}`, {
      withCredentials: true,
      responseType: "blob", 
    }));

    let filename = "Rulebook.zip";
    const disposition = response.headers["content-disposition"];
    if (disposition) {
      const match = disposition.match(/filename="?(.+)"?/);
      if (match?.[1]) {
        filename = match[1];
      }
    }

    return { blob: response.data, filename };
  } catch (error) {
    // Axios errors can be typed more specifically if desired
    if (axios.isAxiosError(error)) {
      throw error;
    }
    throw error;
  }
}

export async function getInsights(notification_id: string): Promise<any> {
  try {
    const response = await axiosRequest(axios.get(
      `/api/data/insights?notification_id=${notification_id}`,
      { withCredentials: true }
    ));
    return response.data;
  } catch (error: any) {
    if (axios.isAxiosError(error)) {
      throw error;
    }
    throw error;
  }
}

export async function downloadInsights(docName: string, session: string) {
  try {
    const response = await axiosRequest(axios.get(
      `/api/data/download_insights?doc_name=${docName}&session=${session}`,
      {
        withCredentials: true,
        responseType: 'arraybuffer',
        headers: {
          Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        },
      }
    ));
    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    return blob;
  } catch (error: any) {
    if (axios.isAxiosError(error)) {
      throw error;
    }
    throw error;
  }
}

export async function downloadPayrollData(docName: string, uploadId: string) {
  try {
    const response = await axiosRequest(axios.get(
      `/api/data/download_payroll_data?doc_name=${docName}&upload_id=${uploadId}`,
      {
        responseType: "blob",
        withCredentials: true,
      }
    ));
    return response.data;
  } catch (error: any) {
    if (axios.isAxiosError(error)) {
      throw error;
    }
    throw error;
  }
}

export async function getAnalysisLogs(doc_name: string, session: string): Promise<string> {
  try {
    const response = await axiosRequest(axios.get(`/api/data/get_analysis_logs`,
      {
        params: { doc_name, session },
        responseType: 'blob',
        withCredentials: true,
      }
    ));

    
    return response.data;

  } catch (error: any) {
    if (axios.isAxiosError(error)) {
      throw error;
    }
    throw error;
  }
}

export const readNotification = async (notification_id: string) => {
  try {
    const response = await axiosRequest(axios.get(`/api/data/read_notifications?notification_id=${notification_id}`,
      { withCredentials: true }
    ));
    return response.data;
  } catch (error: any) {
    console.error("Read notification error:", error);
    throw error;
  }
};